import { FC } from 'react'
import { FormActionsProps } from './Forms.d'

const FormActions: FC<FormActionsProps> = ({ formFooter, className }) => {
    return (
        <div
            className={
                'p-dialog border-0 mb-4' + (className && ' ' + className)
            }
        >
            <div className="p-dialog-footer mb-4">{formFooter}</div>
        </div>
    )
}

export default FormActions
